import {useState,useEffect,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {all_routes} from "../../../router/all_routes";
import Table from "../../../../core/dataTable/index";
import Modal_Item_Add from "../item/modalItemAdd";
import Select from "react-select";
import {Toaster} from 'react-hot-toast';
// -- biz9 --
import {Str} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {Message,Type,Title,Config,CMS_Config} from "../../../../constant";
import {App,Data,Image,Style,Toast_Message} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field,Portal_Remote_Image} from "biz9-portal-app";
const Dashboard_App_Content = () => {
    /* -- DEFINE -- *
     * --- BUTTONZ ---
     * btn_post_copy - copy item
     * btn_post_delete - delete item
    */
    const navigate = useNavigate();
    const timeoutRef = useRef(null);
    const [val_sub_page_title,setValSubPageTitle] = useState(Str.get_table_by_name(Portal_Table.CONTENT,{plural:true}));
    const [val_search,setValSearch] = useState("");
    const [stop_search,setStopSearch] = useState('');
    const [contents,setContents] = useState([]);
    const [val_type,setValType] = useState(null);
    const [types,setTypes] = useState([]);
    const [val_category,setValCategory] = useState(null);
    const [categorys,setCategorys] = useState([]);
    // -- paging --
    const [val_page_current,setValPageCurrent] = useState(Type.PAGE_CURRENT);
    const [val_page_size,setValPageSize] = useState(Type.PAGE_SIZE);
    const [val_total,setValTotal] = useState(0);
    const [val_filter,setValFilter] = useState({});
    const [val_sort_by,setValSortBy] = useState({});
    const [val_option,setValOption] = useState({});

    const columns = [
    {
title: "Title",
           dataIndex: "title",
           key: "title",
           render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_app_content_edit+"?id="+record.id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={all_routes.dashboard_app_content_edit+"?id="+record.id} className="text-dark">
                  {Str.get_truncate(record.title,CMS_Config.ITEMS_TITLE_COUNT)}
                    </Link>
                   </h2>
                   ),
            sorter: true
    },
    {
title: "Type",
       dataIndex: "Type",
       key: "Type",
       render: (text: string, record: any) => (
               <>
               {record.type}
               </>
               ),
            sorter: true
    },
    {
title: "Category",
       dataIndex: "category",
       key: "category",
            sorter: true
    },
    {
title: "Visible",
       dataIndex: "setting_visible",
       key: "setting_visible",
       render: (text: string, record: any) => (
               <>
               {record.setting_visible =="1" ? <FeatherIcon icon="plus" /> :<FeatherIcon icon="minus" />}
               </>
               ),
            sorter: true
    },
    {
title: "Action",
       dataIndex: "action",
       render: (res: string, record: any) => (
               <>
               <div className="dropdown dropdown-action">
               <Link to="#" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false">
               <FeatherIcon icon="more-vertical" />
               </Link>
               <div className="dropdown-menu dropdown-menu-right">
               <Link className="dropdown-item" to="#" onClick={(e) => { {btn_post_copy(record.id)} }} >
               <FeatherIcon icon="copy" /> Copy
               </Link>
               <Link className="dropdown-item" to="#" onClick={(e) => { {btn_post_delete(record.id)} }} >
               <FeatherIcon icon="trash" /> Delete
               </Link>
               </div>
               </div>
               </>
               ),
    },
    ];
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_data();
            if(timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            }
            },[]);
    async function get_data () {
        let search = Data_Logic.get_search(Portal_Table.CONTENT,val_filter,{page_current:val_page_current,page_size:val_page_size});
        const option = {};
        const [response,data] = await Portal_Remote_CMS.search(App.get_url(Portal_Url.CMS_SEARCH),search,option);
        bind_items(data);
        Toast_Message.dismiss();
    };
    async function bind_items(data){
        let set_types = Data.get_type_categorys(data.types,{any:true});
        setTypes(set_types);
        let set_categorys = Data.get_type_categorys(data.categorys,{any:true});
        setCategorys(set_categorys);
        setContents(data.items);
        setValTotal(data.item_count);
    };
    const post_search = (e) => {
        const value = Str.get_trim(e.target.value);
        setValSearch(value);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
                setStopSearch(value);
                let filter = {};
                if(value){
                filter = Data.get_item_search_filter(value);
                }
                let search = Data_Logic.get_search(Portal_Table.CONTENT,filter);
                post_search_data(search);
                }, 500);
    };
    async function post_search_data(search) {
        Toast_Message.loading(Message.SEARCHING);
        const option = {};
        const [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
        setContents(data[Portal_Type.ITEMS]);
        setValTotal(data[Portal_Type.ITEM_COUNT]);
        Toast_Message.dismiss();
    };
    async function btn_post_copy(id: any) {
      // -- post-copy-item --
        Toast_Message.loading(Message.SAVING);
        const option = {};
        const [response,data] = await Portal_Remote_CMS.copy(App.get_url(Portal_Url.CMS_COPY),Portal_Table.CONTENT,id,option);
        setContents([data, ...contents]);
        Toast_Message.success(response.message);
     };
    async function btn_post_delete(id: any) {
        if(window.confirm(Message.CONFIRM)){
            Toast_Message.loading(Message.DELETING);
            const option = {};
            const [response,data] = await Portal_Remote_CMS.delete_ids(App.get_url(Portal_Url.CMS_DELETE_IDS),Portal_Table.CONTENT,[id],option);
            setContents(contents.filter(item=>item.id!==id));
            Toast_Message.success(response.message);
        }
    };
    const updateNewItem = (item) => {
        setContents([item, ...contents]);
    };
    const updateValType = (selectedOption) => {
        let search = Data_Logic.get_search(Portal_Table.CONTENT,Data.get_type_category_search_filter(selectedOption.label,val_category?val_category.label:"Any"));
        post_search_data(search);
        setValType(selectedOption);
    };
    const updateValCategory = (selectedOption) => {
        let search = Data_Logic.get_search(Portal_Table.CONTENT,Data.get_type_category_search_filter(val_type?val_type.label:"Any",selectedOption.label));
        post_search_data(search);
        setValCategory(selectedOption);
    };
    return (
            <>
  <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="container px-0">
            {/*Inner Content */}
            <div className="content mx-4 mb-4">
            <div className="main-title my-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="wallet-wrap">
            <div className="wallet-list">
            <div className="wallet-item mt-10">
            <div  className="pt-10">
            <input type='text' autoComplete='off' className='form-control' placeholder={"Search"} value={val_search} onChange={post_search}/>
            </div>
            </div>
            </div>
            <div className="d-flex align-items-center">
            <Link to="#" data-bs-toggle="modal" data-bs-target="#withdraw" className="btn btn-primary">
            Add
            </Link>
            </div>
            </div>
            <div className="table-filter pb-4">
            <ul className="filter-item">
            <li>
            <div className="dropdown">
            <Select  placeholder={'Filter Type'}  classNamePrefix="react-select" className="select" styles={Style.customStyles} options={types} value={val_type} onChange={updateValType} />
            </div>
            </li>
            <li>
            <div className="dropdown">
            <Select  placeholder={'Filter Category'}  classNamePrefix="react-select" className="select" styles={Style.customStyles} options={categorys} value={val_category} onChange={updateValCategory} />
            </div>
            </li>
            </ul>
            </div>
            <div className="table-responsive custom-table">
            <Table onUpdate={setContents} allow_multiple={true}  page_size={val_page_size} page_current={val_page_current} total={val_total} option={val_option} sort_by={val_sort_by} filter={val_filter} table={Portal_Table.CONTENT} dataSource={contents} columns={columns} Selection={false} />
            </div>
            <div className="table-footer">
            <div id="tablepage" />
            </div>
            </div>
            {/* /Inner Content */}
    </div>
        </div>
        {/* /Page Content */}
    <Modal_Item_Add toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} onUpdate={updateNewItem} table={Portal_Table.CONTENT}/>
        </>
        );
};
export default Dashboard_App_Content ;
